import { MedplumRequestOptions } from "@medplum/core";
import { Resource } from "@medplum/fhirtypes";

/**
 * Formats a versionId as the weak ETag that `If-Match` carries. Medplum reads the version out of
 * the quoted portion, so a bare versionId has nothing to match and the precondition is dropped.
 *
 * @param versionId - The resource's `meta.versionId`
 * @returns The weak ETag, e.g. `W/"7"`
 */
export function toWeakETag(versionId: string): string {
  return `W/"${versionId}"`;
}

/**
 * Builds the request options that guard an update with the version the resource was read at, so a
 * resource changed since that read is refused instead of overwritten.
 *
 * @param resource - Resource as it was read
 * @returns Request options with the `If-Match` header, or `undefined` when the version is unknown
 */
export function ifMatchVersionOptions(resource: Resource): MedplumRequestOptions | undefined {
  const versionId = resource.meta?.versionId;
  if (!versionId) return undefined;
  return { headers: { "If-Match": toWeakETag(versionId) } };
}
